import { Component, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'price-info-modal',
  templateUrl: './price-info-modal.component.html',
  styleUrls: ['./price-info-modal.component.scss'],
})
export class PriceInfoModalComponent implements OnInit {
  @Input() priceInfo: any;

  constructor(private modalController: ModalController) {}

  ngOnInit() {}

  async proceedForBooking() {
    this.modalController.dismiss({
      proceedForBooking:true
    });
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
